export class CognitoError extends Error {
  readonly code: string;

  constructor(message: string, code: string) {
    super(message);
    this.name = "CognitoError";
    this.code = code;
  }
}
